module.exports = "<md-progress-circular md-mode=indeterminate class=loading></md-progress-circular> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-loading/tsz-loading.html
// module id = 135
// module chunks = 1